import React from 'react';
import { Box, SkeletonGroup, SkeletonRectangle, Text } from '@wix/design-system';
import { useProductDescription } from '../../hooks/useProductDescription';
export const ProductDescription = _ref => {
  let {
    productId
  } = _ref;
  const {
    description,
    isLoading
  } = useProductDescription({
    productId
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Box, {
      marginTop: "SP1"
    }, /*#__PURE__*/React.createElement(SkeletonGroup, null, /*#__PURE__*/React.createElement(SkeletonRectangle, {
      height: "14px",
      width: "180px",
      dataHook: "product-description-skeleton"
    })));
  }
  if (!description) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    marginTop: "SP1"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small"
  }, description));
};
//# sourceMappingURL=ProductDescription.js.map